import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./LandingPage";
import SimApp from "./SimApp";
import SimAppPrint from './SimAppPrint';
import ViewSentApplication from './ViewSentApplication';
import ProtectedRoute from './ProtectedRoute';
import ViewSentApplicationInst from './ViewSentApplicationInst';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/simApp" element={
          <ProtectedRoute requiredRole="Institute">
            <SimApp />
          </ProtectedRoute>
        } />
        <Route path="/ViewSentApplication" element={
          <ProtectedRoute requiredRole="Admin">
            <ViewSentApplication />
          </ProtectedRoute>
        } />
        <Route path="/ViewSentApplicationInst" element={
          <ProtectedRoute requiredRole="Institute">
            <ViewSentApplicationInst />
          </ProtectedRoute>
        } />
        <Route path="/print/:id" element={<SimAppPrint />} />
      </Routes>
    </Router>
  );
}

export default App;
